"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var fmoney_1 = require("../methods/fmoney");
var mround_1 = require("../methods/mround");
var fnumber_1 = require("../methods/fnumber");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var getRuleMessage_1 = require("../JSchema/getRuleMessage");
/**
 * obiekt reprezentujący wartośc liczbową
 *
 * @export
 * @class WrappedPropertyNumber
 * @extends {WrappedPropertyBase<INumberInternal>}
 * @implements {IWrappedProperty}
 */
var WrappedPropertyNumber = /** @class */ (function (_super) {
    __extends(WrappedPropertyNumber, _super);
    function WrappedPropertyNumber(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        (0, functions_1.wrapSchemaProps)(_this.$schema, _this._internal, 'number', [
            'minimum',
            'maximum',
            'exclusiveMaximum',
            'exclusiveMinimum',
            'precision'
        ]);
        if (_this.$schema.warnings) {
            (0, functions_1.wrapWarningProps)(_this.$schema, _this._internal, 'number', [
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum'
            ]);
        }
        _this._internal.typeok = true;
        (0, functions_1.initVue)(_this, _this._internal);
        return _this;
    }
    /**
     * sprawdza pole pod kątem błedów
     *
     * @param {*} [value] wartość
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} wynik
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyNumber.prototype.$validate = function (value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        // console.time('(number)$validate');
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === null) {
            // console.timeEnd('(number)$validate');
            if (!this._internal.typeok) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'type', value, this.$schema);
                this.$validateResult = {
                    validation: 'type',
                    message: message,
                    expected: this._internal.schema.type,
                    stringValue: this.$stringValue
                };
                return message;
            }
            if (this.$schema.fieldRequired) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message: message,
                    expected: true
                };
                return message;
            }
            return null;
        }
        if (this.$schema.enum) {
            if (this.$schema.enum.indexOf(value) === -1) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'enum', value, this.$schema);
                this.$validateResult = {
                    validation: 'enum',
                    message: message,
                    expected: this.$schema.enum
                };
                return message;
            }
        }
        var ivalue = +value;
        // console.timeEnd('(number)$validate');
        return _super.prototype.$validate.call(this, ivalue);
    };
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyNumber.prototype.$check = function (value, skipDirty, checkResult) {
        if (!this.$disabled && this._internal.schema.warnings) {
            this.$checkResult = [];
            if (value === undefined) {
                value = this.$model;
            }
            // console.time('(number)$validate');
            if (!skipDirty) {
                this.$dirty = true;
            }
            checkResult = checkResult || [];
            if (value === null) {
                // console.timeEnd('(number)$validate');
                if (this.$schema.warnings.fieldRequired) {
                    var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'required',
                        message: message,
                        expected: true
                    });
                    checkResult.push(message);
                }
                if (this.$schema.warnings.enum) {
                    if (this.$schema.warnings.enum.indexOf(value) === -1) {
                        var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'enum', value, this.$schema);
                        this.$checkResult.push({
                            validation: 'enum',
                            message: message,
                            expected: this.$schema.warnings.enum
                        });
                        checkResult.push(message);
                    }
                }
                return checkResult;
            }
            var ivalue = +value;
            // console.timeEnd('(number)$validate');
            return _super.prototype.$check.call(this, ivalue, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    };
    Object.defineProperty(WrappedPropertyNumber.prototype, "$stringValue", {
        /**
         * pobranie wartości tekstowej pola
         *
         * @readonly
         * @type {(string | null)}
         * @memberof WrappedPropertyNumber
         */
        get: function () {
            return this.$getUserData('stringValue', null);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyNumber.prototype.getValue = function () {
        var ivalue = this.$model;
        // let ivalue = obj.$model;
        /*
        if (this.$dirty) {
          this.$validate(ivalue);
        }
        */
        var stringValue = this.$getUserData('stringValue', null);
        if (ivalue === null) {
            // const svalue = this._internal.vm.stringValue;
            // if (svalue !== undefined && svalue !== null) {
            if (stringValue !== null) {
                return stringValue;
            }
            else {
                return '';
            }
        }
        if (isNaN(+ivalue)) {
            ivalue = 0;
        }
        // const err = validate(obj, ivalue);
        // if (obj.$path === 'LiczbaOdbiorcowZadania') {
        //  console.log('validate ', JSON.stringify(ivalue), JSON.stringify(err));
        // }
        // vm.error = err ? getRuleMessage(schema, err, ivalue, $schema) : null;
        // let svalue = (""+self.mround(ivalue)).replace(".",",");
        var svalue = '';
        switch (this.$schema.type) {
            case 'number':
                if (this.$schema.precision === undefined) {
                    svalue = (0, fnumber_1.default)(ivalue, 8);
                }
                else {
                    svalue = (0, fnumber_1.default)(ivalue, this.$schema.precision);
                }
                break;
            case 'money':
                if (this.$schema.precision === undefined) {
                    svalue = (0, fmoney_1.default)(ivalue, false, 2);
                }
                else {
                    svalue = (0, fmoney_1.default)(ivalue, false, this.$schema.precision);
                }
                break;
            case 'integer':
                svalue = (0, fnumber_1.default)(ivalue, 0);
                break;
        }
        // console.log($schema.type + 'Computed(get)', propName, JSON.stringify(svalue), err);
        return svalue;
    };
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyNumber
     */
    WrappedPropertyNumber.prototype.setValue = function (newValue) {
        if (this.$disabled) {
            return;
        }
        this._internal.typeok = true;
        var ivalue = null;
        if (!this._options.dirtyOnInput) {
            this.$dirty = true;
        }
        // console.log('set model', JSON.stringify(newValue));
        if (newValue === '' || newValue == null) {
            /*
            if (this.$dirty && this.$schema.fieldRequired) {
              this.$error = getRuleMessage(this._internal.schema, 'required', newValue, this.$schema);
              // ok = false;
              // typeok = false;
            }
            */
            /*
                                      if (schema.default !== undefined) {
                                          ivalue = schema.default;
                                          //if (ivalue===0) {
                                          //    typeok=true;
                                          //}
                                      }
                                      */
            ivalue = null;
            // this.$setUserData('stringValue', null);
        }
        else {
            ivalue = +newValue.replace(',', '.');
            if (isNaN(ivalue)) {
                /*
                if (this.$dirty) {
                  this.$error = getRuleMessage(this._internal.schema, 'type', newValue, this.$schema);
                }
                this._internal.typeok = false;
                */
                this._internal.typeok = false;
                // this.$setUserData('stringValue', newValue);
                // this.stringValue = newValue;
                // ivalue = schema.default || null;
                ivalue = null;
            }
            else {
                // this.$setUserData('stringValue', null);
            }
        }
        // savedValue = ivalue;
        // if (this.focused) {
        if (!this._internal.typeok) {
            // tslint:disable-next-line: no-console
            // console.log('set $stringValue', newValue);
            this.$setUserData('stringValue', newValue);
            // this._internal.vm.stringValue = newValue;
        }
        else {
            this.$setUserData('stringValue', null);
            // this._internal.vm.stringValue = null;
        }
        var dvalue = 0;
        if (ivalue === null) {
            this.$model = null;
        }
        else {
            switch (this.$schema.type) {
                case 'integer':
                    // console.log('set model', obj.$path, JSON.stringify(ivalue), JSON.stringify(mround(ivalue, 0)));
                    dvalue = (0, mround_1.default)(ivalue, 0);
                    break;
                case 'money':
                    if (this.$schema.precision === undefined) {
                        dvalue = (0, mround_1.default)(ivalue, 2);
                    }
                    else {
                        dvalue = (0, mround_1.default)(ivalue, this.$schema.precision);
                    }
                    break;
                case 'number':
                    if (this.$schema.precision === undefined) {
                        dvalue = (0, mround_1.default)(ivalue, 8);
                    }
                    else {
                        dvalue = (0, mround_1.default)(ivalue, this.$schema.precision);
                    }
                    break;
            }
            // console.log(schema.type + 'Computed(set)', propName, JSON.stringify(dvalue), JSON.stringify(typeok));
            // parent[propName] = dvalue;
            this.$model = dvalue;
        }
    };
    return WrappedPropertyNumber;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.integer = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.number = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.money = WrappedPropertyNumber;
//# sourceMappingURL=WrappedPropertyNumber.js.map